import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
import {GetOrderDetails} from "../../../../reduxToolkit/Providers/providersApi";
import routes from "../../../../Routes/routes";
import {calculateHeight, errorMsg} from "../../../../Apis/functions";
import ButtonActionsCard from "../../../../components/buttons/ButtonActionsCard";
import {ArrowRightIcon} from "../../../../components/buttons/IconButtons";
import {USER_TYPE_NAME_MODEL} from "../../../../enums/userTypeEnum";

/**
 * @file OrderDetailApp.jsx
 * @description Custom hook for managing the logic and state of the order detail view in the supplier workflow.
 *
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 */

/**
 * Custom React hook that manages the business logic for viewing and deleting a supplier's purchase order.
 *
 * It provides:
 * - Fetching order details by ID from URL params
 * - Deleting an order
 * - Controlling related UI states (modals, selected items)
 *
 * @returns {Object} Object containing state variables and handler functions for use in the order detail component.
 */
export const OrderDetailApp =()=>{

    const { t } = useTranslation();
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const userType = user?.data?.userType?.name;
    const [deleteOrderShow, setDeleteOrderShow] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState([]);
    const [getOrderDetails,setGetOrderDetails] = useState(null);
    const [modified,setModified] = useState(null);

    const availableHeightColumnOneRef = useRef(null);
    const availableHeightColumnTwoRef = useRef(null);
    const containerHeightRef = useRef(null);
    const supplierEmployeeUser = getOrderDetails?.supplierEmployee?.user;
    const supplierVehicle = getOrderDetails?.supplierVehicle?.vehicle;

    useEffect(() => {
        calculateHeight({elementRef: availableHeightColumnOneRef, bottom:30});
        calculateHeight({elementRef: availableHeightColumnTwoRef, bottom:30});
        calculateHeight({elementRef: containerHeightRef, bottom:60});
    }, [getOrderDetails]);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if (modified) {
            getData();
            setModified(false);
        }
    }, [modified]);

    const getData =() =>{
        dispatch(GetOrderDetails(id)).then(({payload:{data:{data,success,code}}})=>{
            if (success) setGetOrderDetails(data);
            else errorMsg(code);
        });
    }

    const renderEmployeeButton = (item) => {
        let go;
        let back;
        if(userType === USER_TYPE_NAME_MODEL.EMPLOYEE){
            go =  routes.employee.supplierEmployeeDetails + item?.id;
            back =  routes.employee.orderDetails + id;
        }else{
            go =  routes.suppliers.employeeDetails + item?.id;
            back =  routes.suppliers.ordersDetail + id;
        }

        return (
            <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
                <ButtonActionsCard
                    id='btn_oda_actions_card'
                    name={'details'}
                    Icon={ArrowRightIcon}
                    onClick={() => navigate(go,{state: {backUrl: back}})}
                />
            </div>
        );
    };

    const renderVehicleButton = (item) => {
        let go;
        let back;
        if(userType === USER_TYPE_NAME_MODEL.EMPLOYEE){
            go =  routes.employee.supplierVehicleDetails + item?.id;
            back =  routes.employee.orderDetails + id;
        }else{
            go =  routes.vehicleSupplier.details + item?.id ;
            back =  routes.suppliers.ordersDetail + id;
        }
        return (
            <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
                <ButtonActionsCard
                    id={'btn_oda_actions_card'}
                    name={'details'}
                    Icon={ArrowRightIcon}
                    onClick={() => navigate(go,{state: {backUrl: back}})}
                />
            </div>
        );
    };

    return {
        userType,
        deleteOrderShow,
        setDeleteOrderShow,
        deleteItemId,
        setDeleteItemId,
        renderEmployeeButton,
        renderVehicleButton,
        supplierEmployeeUser,
        supplierVehicle,
        t,
        navigate,
        getOrderDetails,
        dispatch,
        availableHeightColumnOneRef,
        availableHeightColumnTwoRef,
        containerHeightRef
    };
};
